import { Component, inject } from "@angular/core";
import { CommonModule, AsyncPipe } from "@angular/common";
import { LoginService } from "@dert-services";
import { BehaviorSubject, map, Observable, startWith } from "rxjs";
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateModule } from "@ngx-translate/core";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-desktop-person-info",
  templateUrl: "./person-info.component.html",
  styleUrls: ["./person-info.component.scss"],
  standalone: true,
  imports: [CommonModule, AsyncPipe, TranslateModule],
})
export class DesktopPersonInfoComponent {
  private readonly loginService = inject(LoginService);

  displayName = toSignal(
    this.loginService.loginChanged.pipe(
      startWith(this.loginService.user),
      map(user => user?.DisplayName ?? ''),
    ),
    { initialValue: '' },
  );

  businessUnitID = toSignal(
    this.loginService.loginChanged.pipe(
      startWith(this.loginService.user),
      map(user => user?.SelectedBusinessUnit ?? null),
    ),
    { initialValue: null },
  );

  currencyCode = toSignal(
      this.loginService.loginChanged.pipe(
      startWith(this.loginService.user),
      map(user => user?.CurrencyCode ?? ''),
    ),
    { initialValue: '' },
  );

  roles = toSignal(
    this.loginService.loginChanged.pipe(
      startWith(this.loginService.user),
      map(user =>  {
        if (environment.production) {
          return undefined;
        }
        return user?.Roles.reduce((acc, role) => acc + role + ',', '') ?? '';
      }),
    ),
    { initialValue: '' },
  );


  ngOnInit() {
  }
}


//
